import { useEffect, useState } from 'react';
import fetchBundlesSuggested from '../utils/fetch-bundles-suggested';
import fetchMaterialWithSuggestions from '../utils/fetch-material-with-suggestions';

type UseBundleUpsellingProps = { cartItems: CartItem[]; isEnabled?: boolean };
type UseBundleUpsellingReturn = { materialId: number | null; bundles: Material[] };

const SUGGESTIONS_LIMIT = 3;

const useBundleUpselling = ({ cartItems = [], isEnabled }: UseBundleUpsellingProps): UseBundleUpsellingReturn => {
    const [state, setState] = useState<UseBundleUpsellingReturn>({ materialId: null, bundles: [] });

    const materialIds = cartItems.map((cartItem): number => cartItem.material.id);

    useEffect((): void => {
        if (!isEnabled) {
            setState({ materialId: null, bundles: [] });

            return;
        }

        const handleUpselling = async (): Promise<UseBundleUpsellingReturn | void> => {
            const material = await fetchMaterialWithSuggestions({ materialIds, limit: SUGGESTIONS_LIMIT });

            if (!material) {
                return;
            }

            const bundles = await fetchBundlesSuggested({ bundleIds: material.bundleIds });

            return bundles.length > 0 ? { materialId: material.id, bundles } : undefined;
        };

        handleUpselling()
            .then((result): void => result && setState(result))
            .catch((error): void => console.error(error?.message ?? error?.statusText ?? error));
    }, [materialIds.join(''), isEnabled]);

    return state;
};

export default useBundleUpselling;
